import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class TradeIn
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	signup(data, callback)
	{
		this.backend.callBackend(`${Endpoints.tradein.public}/sign-up`, callback, "POST", data);
	}

	verifyEmail(code, username, callback)
	{
		this.backend.callBackend(`${Endpoints.tradein.public}/confirm-sign-up`, callback, "POST", {confirmationCode: code, username: username});
	}

	resendConfirmation(username, callback)
	{
		this.backend.callBackend(`${Endpoints.tradein.public}/resend-confirmation-code`, callback, "POST", {username: username});
	}

}